import { render, staticRenderFns } from "./MultiLineBehaviorEditor.vue?vue&type=template&id=4be84c3b&"
import script from "./MultiLineBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiLineBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports